import {PosologySchedule} from '../backend/enums/posology-schedule';

export type WeekDay =
  | 'sunday'
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday';

export enum Frequency {
  Hourly = 'hourly',
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export type FrequencyType = Lowercase<keyof typeof Frequency>;

export enum SchedulerTypes {
  ActivityGroup = 'activities-group-schedule',
  ActivityType = 'activity-type-schedule',
  CareService = 'care-service-schedule',
}

export type TimeListItem = {
  time: string;
  quantity: number;
};

export type PeriodOfTheDayItem = {
  activityTypeId: string;
  quantity: number;
};

export type ActivitiesGroupSchedule = {
  type: 'activities-group' | 'activity-type';
  // Moment ISOstring
  startDate?: string;
  frequency: Exclude<FrequencyType, 'hourly'>;
  frequencyValue?: number;
  days?: Array<WeekDay>;
};

export type ActivityTypeSchedule = {
  frequency: FrequencyType;
  frequencyValue: number;
  // Moment ISOstring
  endDate?: string;
  // Moment ISOstring
  endHour?: string;
  days?: Array<WeekDay>;
};

export type PosologyScheduleFormType = {
  // Type of posology schedule
  posologyScheduleType: PosologySchedule;

  // Options for PosologySchedule.TimesList
  timesList?: TimeListItem[];

  // Options for PosologySchedule.PeriodsOfTheDay
  periodsOfTheDay?: PeriodOfTheDayItem[];

  // Options for PosologySchedule.Repetition
  repetitionQuantity?: number;
} & ActivityTypeSchedule;

export type TimeListSchedule = {
  posologyScheduleType: PosologySchedule.TimesList;
  timesList: TimeListItem[];
} & ActivityTypeSchedule;

export type PeriodsOfTheDaySchedule = {
  posologyScheduleType: PosologySchedule.PeriodsOfTheDay;
  periodsOfTheDay: PeriodOfTheDayItem[];
} & ActivityTypeSchedule;

export type RepetitionSchedule = {
  posologyScheduleType: PosologySchedule.Repetition;
  repetitionQuantity: number;
} & ActivityTypeSchedule;

export type SosSchedule = {
  posologyScheduleType: PosologySchedule.SOS;
} & ActivityTypeSchedule;
